export default "__VITE_PUBLIC_ASSET__0f2b0ba8__"